import { render, staticRenderFns } from "./BarChartHorizontal.vue?vue&type=template&id=a510e4fc&"
import script from "./BarChartHorizontal.vue?vue&type=script&lang=js&"
export * from "./BarChartHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports